import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FaGraduationCap, FaFileAlt, FaMicrophone, FaBookOpen, FaExternalLinkAlt, FaUsers, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Logo12 from '../../assets/Logo-RB.png';
import Logo4 from '../../assets/logo4.jpg';

const AboutContainer = styled.div`
font-family: sans-serif;
  background: linear-gradient(135deg, #f4f1e8 0%, #faf9f6 100%);
  padding: 2.5rem;
  border-radius: 20px;
  box-shadow: 0 6px 20px rgba(45, 80, 22, 0.1);
  margin-bottom: 2.5rem;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
`;

const SectionTitle = styled.h2`
  font-family: 'Chau Philomene One';
  font-size: 2rem;
  color: #2d5016;
  text-align: center;
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-weight: 700;
`;

const Subtitle = styled.h2`
  font-family: 'karla', sans-serif';
  font-size: 2rem;
  color: #1e8909e4;
  text-align: center;
  margin-bottom: 1.5rem;
display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
  font-weight: 400;
`;

const ProjectIntro = styled.div`
  background: #faf9f6;
  padding: 2rem;
  border-radius: 15px;
  margin-bottom: 2rem;
  border: 2px solid #e8e4d8;
  box-shadow: 0 4px 12px rgba(45, 80, 22, 0.08);
  text-align: justify;
  line-height: 1.8;

  h3 {
    font-family: 'Chau Philomene One';
    color: #2d5016;
    font-size: 1.8rem;
    margin-bottom: 1rem;
    font-weight: 700;
  }

  p {
    font-size: 1rem;
    color: #3a3434;
    margin-bottom: 1rem;
    line-height: 1.7;
  }

  strong {
    color: #2d5016;
    font-weight: 700;
  }

  a {
    color: #3d6b1f;
    font-weight: 600;
    
    &:hover {
      color: #2d5016;
    }
  }
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

const TeamCard = styled.div`
  background: #faf9f6;
  padding: 1.5rem;
  border-radius: 15px;
  border: 2px solid #e8e4d8;
  box-shadow: 0 4px 12px rgba(45, 80, 22, 0.08);
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    border-color: #3d6b1f;
    box-shadow: 0 12px 28px rgba(61, 107, 31, 0.18);
  }
`;

const PersonImage = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #3d6b1f;
  margin-bottom: 0.5rem;
  box-shadow: 0 4px 10px rgba(61, 107, 31, 0.2);
`;

const AvatarPlaceholder = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f4f1e8 0%, #e8e4d8 100%);
  color: #3d6b1f;
  font-weight: bold;
  font-size: 1.25rem;
  border: 4px solid #3d6b1f;
  margin-bottom: 0.5rem;
  box-shadow: 0 4px 10px rgba(61, 107, 31, 0.2);
  font-family: 'Chau Philomene One';
`;

const PersonName = styled.h3`
  font-family: 'Chau Philomene One';
  font-size: 1.2rem;
  color: #2d5016;
  margin: 0.5rem 0 0;
  font-weight: 700;
`;

const PersonRole = styled.p`
  font-size: 0.95rem;
  color: #5a6b52;
  margin: 0.5rem 0;
  font-weight: 700;
  text-transform: capitalize;
`;

const PersonDescription = styled.p`
  font-size: 0.9rem;
  color: #3a3434;
  line-height: 1.5;
  margin: 1rem 0;
  font-weight: 400;
`;

const SkillTags = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 1rem;
`;

const SkillTag = styled.span`
  background: #f4f1e8;
  color: #2d5016;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 700;
  border: 2px solid #3d6b1f;
  transition: all 0.3s ease;

  &:hover {
    background: #3d6b1f;
    color: #f4f1e8;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(61, 107, 31, 0.2);
  }
`;

const BackButton = styled.button`
  background: #3d6b1f;
  color: #f4f1e8;
  padding: 0.7rem 1.8rem;
  border-radius: 25px;
  font-family: sans-serif;
  font-weight: bold;
  cursor: pointer;
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 2rem 0;
  box-shadow: 0 4px 10px rgba(61, 107, 31, 0.2);
  transition: all 0.3s ease;

  &:hover {
    background: #2d5016;
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(61, 107, 31, 0.35);
  }

  &:active {
    transform: scale(0.97);
  }
`;

const teamMembers = [
  {
    name: "Nelia Q. Catayas, Ph.D.",
    role: "Dean, College of Technology; Extension/NIA Focal Person",
    description: "Provides academic oversight and approves research standards; ensures the platform aligns with institutional goals for knowledge sharing and sustainability.",
    photo: require('../../Face/yang.jpg'),
    skills: ["Leadership", "Research", "Education"],
  },
  {
    name: "Max Angelo D. Perin",
    role: "Program Lead / System Integrator; Web Development and Enterprises / Information Management Instructor",
    description: "Leads the MAKASA Program research design, system integration, and serves as course instructor.",
    photo: require('../../Face/max.jpg'),
    skills: ["Full Stack", "AI/ML", "Research"],
  },
  {
    name: "Kyla B. Quirequire",
    role: "Frontend Developer / Program Team Lead",
    description: "",
    photo: require('../../Face/5.jpg'),
    skills: ["React", "Node.js", "JavaScript", "Backend", "SQL"],
  },
  {
    name: "Christian Jhon B. Adlaon",
    role: "Program Analyst",
    description: "",
    photo: require('../../Face/L.jpg'),
    skills: ["Data Analysis", "SQL", "Frontend"],
  },
  {
    name: "Maeryn Joyce Pajo",
    role: " ",
    description: "Designed ",
    photo: require('../../Face/j.jpg'),
    skills: ["Design"],
  },
  {
    name: "Ella Mae Ancog",
    role: "Backend Developer ",
    description: ".",
    photo: require('../../Face/9.jpg'),
    skills: ["MySQL", "Support"],
  },
  {
    name: "Aljun Loretero Cruda",
    role: "",
    description: "",
    photo: require('../../Face/m.jpg'),
    skills: ["MySQL", "Support"],
  },
  {
    name: "Michael Angelo Jamil VII",
    role: "Assistant Program Leader",
    description: "Supports program coordination and backend development;.",
    photo: require('../../Face/10.jpg'),
    skills: ["Backend( SQL tables)"],
  },
  {
    name: "Karl Vallecer",
    role: "Assistant Michael Angelo Jamil VII",
    description: "Assists in backend development and testing; supports database optimization tasks.",
    photo: require('../../Face/3.jpg'),
    skills: ["backend Support"],
  },
];

/* ── Phase 1: Core Leadership & Advisers ── */
const phase1Team = [
  {
    name: "Max Angelo D. Perin",
    role: "Program Lead / System Integrator",
    description: "Leads the MAKASA Program research design, system integration, and dissertation writing.",
    photo: require('../../Face/max.jpg'),
    skills: ["Full Stack", "AI/ML", "Research"],
  },
  {
    name: "Nelia Q. Catayas, Ph.D.",
    role: "Dean; Extension/NIA Focal",
    description: "Provides academic oversight; extension and NIA coordination focal person.",
    photo: require('../../Face/yang.jpg'),
    skills: ["Leadership", "Research", "Education"],
  },
  {
    name: "Larmie S. Feliscuzo",
    role: "CIT-U Adviser / Consultant",
    description: "Dissertation adviser and academic consultant.",
    photo: require('../../Face/larmie.jfif'),
    skills: ["Advisory", "IT Research"],
  },
  {
    name: "Chris Jordan G. Aliac",
    role: "CIT-U Adviser / Consultant",
    description: "Dissertation adviser and academic consultant.",
    photo: require('../../Face/chris.jfif'),
    skills: ["Advisory", "IT Research"],
  },
];

/* ── Phase 2: MAKASA Program Continuation ── */
const phase2Exclusions = [
  "Larmie S. Feliscuzo",
  "Chris Jordan G. Aliac",
];

const phase2Filtered = teamMembers.filter(
  (m) => !phase2Exclusions.some((ex) => m.name.includes(ex))
);

const sortPhase2 = (list) => {
  const nelia = list.find((m) => m.name.includes('Nelia'));
  const max = list.find((m) => m.name.includes('Max Angelo'));
  const kyla = list.find((m) => m.name.includes('Kyla'));
  const rest = list.filter(
    (m) => !m.name.includes('Nelia') && !m.name.includes('Max Angelo') && !m.name.includes('Kyla')
  );
  return [nelia, max, kyla, ...rest].filter(Boolean);
};

const phase2Team = sortPhase2(phase2Filtered);

/* ── Carousel slides config ── */
const phaseSlides = [
  {
    title: 'Phase 1: Core Leadership & Advisers',
    subtitle: '',
    team: phase1Team,
  },
  {
    title: 'Phase 2: MAKASA Program Continuation (College / Extension)',
    subtitle: 'Development Cohort (BISU College / Extension)',
    team: phase2Team,
  },
];

const About = () => {
  const navigate = useNavigate();

  const getInitials = (name) => {
    if (!name) return '';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
  };

  return (
    <AboutContainer>
      <BackButton onClick={() => navigate('/')}>
        ← Back
      </BackButton>

      <SectionTitle>
        <img
          src={Logo12}
          alt="MAKASA Logo"
          style={{
            height: '80px',
            width: 'auto',
            verticalAlign: 'middle',
            marginRight: '8px'
          }}
        />
        About the MAKASA Program
      </SectionTitle>

      <ProjectIntro>
        <h3>M.A.K.A.S.A. Program</h3>
        <p>
          <strong>M.A.K.A.S.A.</strong> (Modeling Agricultural Knowledge using AI for Sustainable Agriculture) is a <strong>program-level research initiative</strong> housed at the College of Technology, Bohol Island State University – Bilar Campus. It serves as an umbrella for AI-driven agricultural projects aligned with sustainable development goals.
        </p>
        <p>
          The current dissertation scope is <strong>narrowed to irrigation</strong> — specifically the assessment and prediction of irrigation status across Bohol's irrigators' associations. This focused scope ensures rigorous research design while remaining extensible to broader agricultural domains in the future.
        </p>
        <p>
          <strong>LISA</strong> (Local Irrigation System Assessment) is the irrigation-focused project output under MAKASA. It operationalizes the dissertation's AI models into a functional web-based tool for NIA field personnel and local stakeholders.
        </p>
        <p>
          The program is aligned with the extension collaboration between <strong>ABAG / NIA × BISU–Bilar</strong>, ensuring that research outputs translate into actionable tools for on-the-ground agricultural support.
        </p>
      </ProjectIntro>

      {/* ── Program Phases & Teams (Carousel) ── */}
      <SectionTitle>
        <FaUsers style={{ marginRight: 8 }} />
        Program Phases &amp; Teams
      </SectionTitle>

      <PhaseCarousel
        slides={phaseSlides}
        getInitials={getInitials}
      />

      {/* Collaboration & Attribution */}
      <AttributionCard>
        <strong>Collaboration Notice:</strong> M.A.K.A.S.A. is a program-level initiative. The dissertation research design, evaluation, manuscript writing, and final integration decisions are led by Max Angelo D. Perin. LISA is the irrigation-focused project under MAKASA and is aligned with extension collaboration (ABAG / NIA × BISU–Bilar). Student contributions are supervised and credited on this site.
      </AttributionCard>

      {/* ── Research Track Timeline ── */}
      <SectionTitle>
        <FaGraduationCap style={{ marginRight: 8 }} />
        Research Track Timeline
      </SectionTitle>
      <Subtitle>Doctor in Information Technology</Subtitle>

      <MilestoneTimeline>
        {/* DIT Research Methods */}
        <MilestoneCard>
          <MilestoneIconWrapper color="#2d5016">
            <FaFileAlt size={22} />
          </MilestoneIconWrapper>
          <MilestoneContent>
            <MilestonePhase>DIT – Research Methods (DSIT)</MilestonePhase>
            <MilestoneTitle>MAKASA Concept / Prototype</MilestoneTitle>
            <MilestoneDesc>
              Initial research paper introducing the M.A.K.A.S.A. Program concept, developed during the Doctor in Information Technology – Research Methods course.
            </MilestoneDesc>
            <MilestoneBadgeRow>
              <MilestoneBadgeLink href="https://ieeexplore.ieee.org/document/10881265/" target="_blank" rel="noopener noreferrer" type="paper"><FaFileAlt size={12} /> Research Paper <FaExternalLinkAlt size={10} /></MilestoneBadgeLink>
            </MilestoneBadgeRow>
          </MilestoneContent>
        </MilestoneCard>

        {/* Dissertation – ICBEIST */}
        <MilestoneCard>
          <MilestoneIconWrapper color="#b8860b">
            <FaMicrophone size={22} />
          </MilestoneIconWrapper>
          <MilestoneContent>
            <MilestonePhase>Dissertation – Scoping to Irrigation</MilestonePhase>
            <MilestoneTitle>ICBEIST 2025 – Presentation</MilestoneTitle>
            <MilestoneDesc>
              Dissertation scope narrowed to irrigation assessment. Paper presented at <strong>ICBEIST 2025</strong> as part of the dissertation track.
            </MilestoneDesc>
            <MilestoneBadgeRow>
              <MilestoneBadge type="presentation"><FaMicrophone size={12} /> Presentation</MilestoneBadge>
            </MilestoneBadgeRow>
          </MilestoneContent>
        </MilestoneCard>

        {/* Dissertation – VMC Analytiks */}
        <MilestoneCard>
          <MilestoneIconWrapper color="#0e6655">
            <FaBookOpen size={22} />
          </MilestoneIconWrapper>
          <MilestoneContent>
            <MilestonePhase>LISA Development + Evaluation</MilestonePhase>
            <MilestoneTitle>VMC Analytiks – Publication</MilestoneTitle>
            <MilestoneDesc>
              LISA development and evaluation results published in <strong>VMC Analytiks</strong> as a dissertation publication output.
            </MilestoneDesc>
            <MilestoneBadgeRow>
              <MilestoneBadgeLink href="https://digi-journalphils.com/predicting-irrigators-association-membership-in-bohol-using-decision-trees-and-random-forests/" target="_blank" rel="noopener noreferrer" type="publication"><FaBookOpen size={12} /> Publication <FaExternalLinkAlt size={10} /></MilestoneBadgeLink>
            </MilestoneBadgeRow>
          </MilestoneContent>
        </MilestoneCard>

        {/* Dissertation – IJRTE */}
        <MilestoneCard>
          <MilestoneIconWrapper color="#1a5276">
            <FaBookOpen size={22} />
          </MilestoneIconWrapper>
          <MilestoneContent>
            <MilestonePhase>Publications / Presentations</MilestonePhase>
            <MilestoneTitle>IJRTE – Publication (SCOPUS-indexed)</MilestoneTitle>
            <MilestoneDesc>
              Paper published in <strong>IJRTE</strong>, a SCOPUS-indexed journal, as part of the dissertation publication requirement.
            </MilestoneDesc>
            <MilestoneBadgeRow>
              <MilestoneBadgeLink href="https://journals.blueeyesintelligence.org/index.php/ijrte/article/view/822" target="_blank" rel="noopener noreferrer" type="publication"><FaBookOpen size={12} /> Publication <FaExternalLinkAlt size={10} /></MilestoneBadgeLink>
            </MilestoneBadgeRow>
          </MilestoneContent>
        </MilestoneCard>

        {/* Dissertation – MCT4SD */}
        <MilestoneCard>
          <MilestoneIconWrapper color="#6c3483">
            <FaGraduationCap size={22} />
          </MilestoneIconWrapper>
          <MilestoneContent>
            <MilestonePhase>Publications / Presentations</MilestonePhase>
            <MilestoneTitle>MCT4SD 2025 – Presentation &amp; Publication</MilestoneTitle>
            <MilestoneDesc>
              Paper presented and published at <strong>MCT4SD 2025</strong> as part of the dissertation track.
            </MilestoneDesc>
            <MilestoneBadgeRow>
              <MilestoneBadgeLink href="https://mct4sd2025.sched.com/event/2CUHi/a-lightweight-deep-learning-classifier-for-farm-irrigation-status-detection-using-image-buffers-and-metadata-a-case-study-from-bohol-philippines?iframe=yes&w=100%25&sidebar=yes&bg=no" target="_blank" rel="noopener noreferrer" type="presentation"><FaMicrophone size={12} /> Presentation <FaExternalLinkAlt size={10} /></MilestoneBadgeLink>
              <MilestoneBadge type="publication"><FaBookOpen size={12} /> Publication</MilestoneBadge>
            </MilestoneBadgeRow>
          </MilestoneContent>
        </MilestoneCard>
      </MilestoneTimeline>

      <div style={{ textAlign: 'center', marginTop: '2rem', color: '#5a6b52', fontSize: '1rem' }}>
        <SectionTitle>
          <img
            src={Logo4}
            alt="MAKASA Logo"
            style={{
              height: '100px',
              width: 'auto',
              verticalAlign: 'middle',
              marginRight: '8px'
            }}
          />
        </SectionTitle>
        <p style={{ color: '#3a3434', fontWeight: 500 }}>
          Developed with care at <strong style={{ color: '#2d5016' }}>ᜉᜈᜈᜎᜒᜃ᜔ᜐᜒᜃᜈ᜔ ᜅ᜔ ᜋᜃᜐ x Full Stack Masters</strong><br />
          ᜉᜈᜈᜎᜒᜃ᜔ᜐᜒᜃ᜔ ᜀᜆ᜔ ᜉᜄ᜔ᜂᜈ᜔ᜎᜇ᜔᜔ ᜐ ᜉᜄ᜔ᜆᜓᜆᜓᜂᜐ᜔ Computing Research and Development

        </p>
      </div>
    </AboutContainer>
  );
};



/* ── PhaseCarousel component ── */
const PhaseCarousel = ({ slides, getInitials }) => {
  const [active, setActive] = useState(0);
  const touchStart = useRef(null);
  const trackRef = useRef(null);

  const total = slides.length;

  const goto = useCallback((i) => {
    setActive((i % total + total) % total);
  }, [total]);

  const prev = useCallback(() => goto(active - 1), [active, goto]);
  const next = useCallback(() => goto(active + 1), [active, goto]);

  /* keyboard */
  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [prev, next]);

  /* touch swipe */
  const onTouchStart = (e) => { touchStart.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touchStart.current === null) return;
    const diff = touchStart.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) { diff > 0 ? next() : prev(); }
    touchStart.current = null;
  };

  const slide = slides[active];

  return (
    <CarouselWrapper
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      ref={trackRef}
    >
      {/* Nav buttons */}
      <CarouselNav aria-label="Previous phase" onClick={prev} side="left">
        <FaChevronLeft size={18} />
      </CarouselNav>
      <CarouselNav aria-label="Next phase" onClick={next} side="right">
        <FaChevronRight size={18} />
      </CarouselNav>

      {/* Slide content */}
      <CarouselSlide key={active}>
        <PhaseSubtitle>{slide.title}</PhaseSubtitle>
        <PhaseCaption>{slide.subtitle}</PhaseCaption>

        <TeamGrid>
          {slide.team.map((member, index) => (
            <TeamCard key={`slide-${active}-${index}`}>
              {member.photo ? (
                <PersonImage src={member.photo} alt={member.name} />
              ) : (
                <AvatarPlaceholder>{getInitials(member.name)}</AvatarPlaceholder>
              )}
              <PersonName>{member.name}</PersonName>
              <PersonRole>{member.role}</PersonRole>
              <PersonDescription>{member.description}</PersonDescription>
              <SkillTags>
                {member.skills.map((skill, i) => (
                  <SkillTag key={i}>{skill}</SkillTag>
                ))}
              </SkillTags>
            </TeamCard>
          ))}
        </TeamGrid>
      </CarouselSlide>

      {/* Dots */}
      <CarouselDots>
        {slides.map((_, i) => (
          <Dot
            key={i}
            $active={i === active}
            onClick={() => goto(i)}
            aria-label={`Go to phase ${i + 1}`}
          />
        ))}
      </CarouselDots>
    </CarouselWrapper>
  );
};

export default About;

/* ── Milestone Styled Components ── */

const MilestoneTimeline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 800px;
  margin: 0 auto 2.5rem;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 27px;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(180deg, #3d6b1f, #b8860b, #1a5276, #6c3483);
    border-radius: 4px;
  }
`;

const MilestoneCard = styled.div`
  display: flex;
  gap: 1.25rem;
  align-items: flex-start;
  background: #faf9f6;
  padding: 1.5rem;
  border-radius: 15px;
  border: 2px solid #e8e4d8;
  box-shadow: 0 4px 12px rgba(45, 80, 22, 0.08);
  margin-left: 15px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: #3d6b1f;
    box-shadow: 0 12px 28px rgba(61, 107, 31, 0.18);
  }
`;

const MilestoneIconWrapper = styled.div`
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ color }) => color || '#3d6b1f'};
  color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 1;
`;

const MilestoneContent = styled.div`
  flex: 1;
`;

const MilestonePhase = styled.span`
  display: inline-block;
  font-size: 0.78rem;
  font-weight: 700;
  color: #5a6b52;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
`;

const MilestoneTitle = styled.h4`
  font-family: 'Chau Philomene One';
  font-size: 1.15rem;
  color: #2d5016;
  margin: 0.15rem 0 0.5rem;
  font-weight: 700;
`;

const MilestoneDesc = styled.p`
  font-size: 0.92rem;
  color: #3a3434;
  line-height: 1.6;
  margin: 0 0 0.75rem;

  strong {
    color: #2d5016;
  }
`;

const MilestoneBadgeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const badgeColors = {
  paper: { bg: '#e8f5e9', color: '#2d5016', border: '#3d6b1f' },
  presentation: { bg: '#fff8e1', color: '#8d6e00', border: '#b8860b' },
  publication: { bg: '#e3f2fd', color: '#1a5276', border: '#2980b9' },
};

const MilestoneBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0.3rem 0.85rem;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 700;
  background: ${({ type }) => badgeColors[type]?.bg || '#f4f1e8'};
  color: ${({ type }) => badgeColors[type]?.color || '#2d5016'};
  border: 2px solid ${({ type }) => badgeColors[type]?.border || '#3d6b1f'};
`;

const MilestoneBadgeLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0.3rem 0.85rem;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  background: ${({ type }) => badgeColors[type]?.bg || '#f4f1e8'};
  color: ${({ type }) => badgeColors[type]?.color || '#2d5016'};
  border: 2px solid ${({ type }) => badgeColors[type]?.border || '#3d6b1f'};
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    filter: brightness(0.92);
  }
`;

const PhaseSubtitle = styled.h3`
  font-family: 'Chau Philomene One', sans-serif;
  font-size: 1.35rem;
  color: #2d5016;
  text-align: center;
  margin: 1.5rem 0 1.25rem;
  font-weight: 700;
  padding-bottom: 0.5rem;
  border-bottom: 2px dashed #c5d6b8;
`;

const AttributionCard = styled.div`
  background: #faf9f6;
  padding: 1.5rem 2rem;
  border-radius: 15px;
  border: 2px solid #e8e4d8;
  box-shadow: 0 4px 12px rgba(45, 80, 22, 0.08);
  margin: 2rem auto 2.5rem;
  max-width: 800px;
  font-size: 0.92rem;
  line-height: 1.7;
  color: #3a3434;
  text-align: justify;

  strong {
    color: #2d5016;
  }
`;

/* ── Carousel Styled Components ── */

const CarouselWrapper = styled.div`
  position: relative;
  margin-bottom: 2rem;
  padding: 0 2.5rem;

  @media (max-width: 600px) {
    padding: 0 0.5rem;
  }
`;

const CarouselSlide = styled.div`
  animation: fadeSlide 0.4s ease;

  @keyframes fadeSlide {
    from {
      opacity: 0;
      transform: translateX(18px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

const CarouselNav = styled.button`
  position: absolute;
  top: 50%;
  ${({ side }) => side}: -4px;
  transform: translateY(-50%);
  z-index: 2;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #3d6b1f;
  background: #faf9f6;
  color: #3d6b1f;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(61, 107, 31, 0.15);
  transition: all 0.25s ease;

  &:hover {
    background: #3d6b1f;
    color: #fff;
    transform: translateY(-50%) scale(1.08);
  }

  @media (max-width: 600px) {
    width: 34px;
    height: 34px;
    ${({ side }) => side}: -2px;
  }
`;

const CarouselDots = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.65rem;
  margin-top: 1.5rem;
`;

const Dot = styled.button`
  width: ${({ $active }) => ($active ? '28px' : '10px')};
  height: 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  background: ${({ $active }) => ($active ? '#3d6b1f' : '#c5d6b8')};
  transition: all 0.3s ease;

  &:hover {
    background: #2d5016;
  }
`;

const PhaseCaption = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 0.95rem;
  color: #5a6b52;
  text-align: center;
  margin: -0.75rem 0 1.5rem;
  font-weight: 500;
`;

